export const DEFAULT_TERM = 60;
